import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import themeReducer from './themeSlice';
import organizationReducer from './organizationSlice';
import vaultReducer from './vaultSlice';
import subscriptionReducer from './subscriptionSlice';
import demoReducer from './demoSlice';
import { persistMiddleware } from './persistMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    organization: organizationReducer,
    vault: vaultReducer,
    subscription: subscriptionReducer,
    // Demo-only animation state. NOT persisted, NOT cross-tab synced —
    // intentionally absent from persistMiddleware (see DEMO_TREASURY_DESIGN.md §3.4).
    demo: demoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(persistMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
